type LogLevel = 'debug' | 'warning' | 'error';

export function log(level: LogLevel, ...messages: any[]) {
  if (process.env.NODE_ENV !== 'production') {
    switch (level) {
      case 'debug':
        console.debug(...messages);
        break;
      case 'warning':
        console.warn(...messages);
        break;
      case 'error':
        console.error(...messages);
        break;
      default:
        throw new Error(`Unknown log level: ${level}`);
    }
    console.log(`[${level.toUpperCase()}]`, ...messages);
  }
}
